import { useColorMode } from "@kobalte/core/color-mode";
import type { Component, ComponentProps } from "solid-js";

import { Toaster as Sonner } from "solid-sonner";
import {
  IconCircleCheck,
  IconCircleX,
  IconInfo,
  IconTriangleAlert,
} from "../icons";

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster: Component<ToasterProps> = (props) => {
  const { colorMode } = useColorMode();

  return (
    <Sonner
      class="toaster group"
      theme={colorMode()}
      icons={{
        success: <IconCircleCheck size={20} class="text-green-600" />,
        error: <IconCircleX size={20} class="text-red-600" />,
        warning: <IconTriangleAlert size={20} class="text-yellow-600" />,
        info: <IconInfo size={20} class="text-blue-600" />,
      }}
      toastOptions={{
        classes: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "text-green-600 dark:text-green-400",
          error: "text-red-600 dark:text-red-400",
          warning: "text-yellow-600 dark:text-yellow-400",
          info: "text-blue-600 dark:text-blue-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
